<template>
    <div class="text-xs-center">
            <v-card>
                <edit-box :user="user"></edit-box>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
    </div>

</template>

<script>
    import Create from '~/pages/users/create.vue'
    export default {
      components: {
        'edit-box' : Create
      },
      props: [ 'user' ],
      data() {


        return {
          name: user.name ,
          email: user.email,
          dialog: true
        }
      }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/users/edit.vue